// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***********expand row problem**************/

.expandInfo{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 120px;
  }
  .contExpandInfo{
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    
  }
  .rowExpand{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--hover-color);
    /* background: #80808047; */
    height: 100%;
    /* color: aliceblue; */
  }
  .menuActionData .compactAction{
    width: 90% !important;
  }
  .menuActionData  .compactAction .actAzul{
    width: 15vh !important;
  }
  .menuActionData  .compactAction  .actDisabled{
    width: 15vh !important;
  }
  .rowExpandWhite{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #3f404ebd;
    /* background: #80808047; */
    height: 100%;
    color: aliceblue;
  }
  .infoCont{
    
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    border-right: 1px solid rgba(128, 128, 128, 0.363);
    
  }
  .headContent{
    
    width:15%;
    height: 100%;
    position: relative;
    display: inline;
    justify-content: center;
    
  }
.rowHeadExpand{
  background: #d8d6d6b6;
  /* background-color: var(--hover-color); */
    width: 100%;
    height: 17%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--txt-color);
    font-size: var(--font-size-xSmall);
font-weight: bold;
letter-spacing: 1px;
border-bottom: 1px solid rgba(128, 128, 128, 0.678);
word-wrap: anywhere;
text-align: center;

}
.detailContent{
  width: 85%;
  height: 100%;
  position: relative;
  display: inline;
  justify-content: center;
  
}
.rowDetailExpand{
  width: 100%;
  height: 17%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--txt-color);
  text-align: center;
font-size: var(--font-size-xSmall);
/* letter-spacing: 1px; */
border-bottom: 1px solid rgba(128, 128, 128, 0.568);

background-color: var(--hover-color);
overflow: auto;
}
.rowcontActions{
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}
.actionsTitle{
  color: var(--main-color);
font-size: small;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lineTitle{
  width: 90%;
position: absolute;
left: 5%;
top: 8%;
color: #505050a3;
height: 1px;
background: #3b3b3ba3;
}

/**************** menu expcept*****************/
.exceptCont{
  position: relative;
  display: block; 
  justify-content: center;
  width: 100%;
  height: 100%;
  border: unset;
  /* background-color: aliceblue; */
}
.formCont{
  position: relative;
  display: flex;
  width: 100%;
  height: 86%;
  border-radius: 0px 0px 10px 10px;
  justify-content: center;
  align-items: top;
}
.formCompact{
  position: relative;
  display: block;
  width: 85%;
  height:95%;
}
.formColumn{
  position: relative;
  display: flex;
  width: 100%;
  height:20%;
  /* margin-top: 5%; */
}



.formColumn.input-column{
  justify-content: center;
  align-items: center;
}
.input-column label{
  color: aliceblue;
}
.contEventsActions .compactAction{
  width: 95%;
  height: 60%;
}

.dateExcepcion{
  width: 70%;
  height: 30%;
  background: transparent;
  color: aliceblue;
  border-radius: 10px;
}
.menuActionCell:hover .tooltiptextAction {
  visibility: visible;
  opacity: 1;
}
.tooltiptextAction {
  visibility: hidden;
  opacity: 0;
  width: 35%;
  height: 30px;
  background-color: #646464c5;
  border: #003757 2px solid;
  color: rgb(245, 245, 245);
  text-align: center;
  border-radius: 5px;
  /* padding: 10px; */
  position: absolute;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  /* bottom: 80%; */
  left: 50%;
  transform: translateX(-50%);
  /* height: 20px; */
  transition: opacity 0.3s;
  /* white-space: nowrap; */
  top: 50%;
  font-size: x-small;
  /* margin: 5px; */
}
.tooltiptextAction::after {
  content: "";
  position: absolute;
  top: 90%;
  left:0%;
  border-width: 8px;
  border-style: solid;
  border-color: #28282817 transparent transparent transparent;
  transform: translateX(-50%);
}`, "",{"version":3,"sources":["webpack://./src/components/styles/MenuAlert.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;;EAEd;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,2BAA2B;IAC3B,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;EAClB;EACA;;IAEE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,kDAAkD;;EAEpD;EACA;;IAEE,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,uBAAuB;;EAEzB;AACF;EACE,qBAAqB;EACrB,0CAA0C;IACxC,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;AACtC,iBAAiB;AACjB,mBAAmB;AACnB,mDAAmD;AACnD,mBAAmB;AACnB,kBAAkB;;AAElB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;;AAEzB;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB,kCAAkC;AAClC,yBAAyB;AACzB,mDAAmD;;AAEnD,oCAAoC;AACpC,cAAc;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B,gBAAgB;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ,kBAAkB;AAClB,QAAQ;AACR,OAAO;AACP,gBAAgB;AAChB,WAAW;AACX,qBAAqB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;;;AAIA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,2DAA2D;EAC3D,2BAA2B;AAC7B","sourcesContent":["/***********expand row problem**************/\r\n\r\n.expandInfo{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 120px;\r\n  }\r\n  .contExpandInfo{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n    \r\n  }\r\n  .rowExpand{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: var(--hover-color);\r\n    /* background: #80808047; */\r\n    height: 100%;\r\n    /* color: aliceblue; */\r\n  }\r\n  .menuActionData .compactAction{\r\n    width: 90% !important;\r\n  }\r\n  .menuActionData  .compactAction .actAzul{\r\n    width: 15vh !important;\r\n  }\r\n  .menuActionData  .compactAction  .actDisabled{\r\n    width: 15vh !important;\r\n  }\r\n  .rowExpandWhite{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background: #3f404ebd;\r\n    /* background: #80808047; */\r\n    height: 100%;\r\n    color: aliceblue;\r\n  }\r\n  .infoCont{\r\n    \r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    display: flex;\r\n    border-right: 1px solid rgba(128, 128, 128, 0.363);\r\n    \r\n  }\r\n  .headContent{\r\n    \r\n    width:15%;\r\n    height: 100%;\r\n    position: relative;\r\n    display: inline;\r\n    justify-content: center;\r\n    \r\n  }\r\n.rowHeadExpand{\r\n  background: #d8d6d6b6;\r\n  /* background-color: var(--hover-color); */\r\n    width: 100%;\r\n    height: 17%;\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-xSmall);\r\nfont-weight: bold;\r\nletter-spacing: 1px;\r\nborder-bottom: 1px solid rgba(128, 128, 128, 0.678);\r\nword-wrap: anywhere;\r\ntext-align: center;\r\n\r\n}\r\n.detailContent{\r\n  width: 85%;\r\n  height: 100%;\r\n  position: relative;\r\n  display: inline;\r\n  justify-content: center;\r\n  \r\n}\r\n.rowDetailExpand{\r\n  width: 100%;\r\n  height: 17%;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: var(--txt-color);\r\n  text-align: center;\r\nfont-size: var(--font-size-xSmall);\r\n/* letter-spacing: 1px; */\r\nborder-bottom: 1px solid rgba(128, 128, 128, 0.568);\r\n\r\nbackground-color: var(--hover-color);\r\noverflow: auto;\r\n}\r\n.rowcontActions{\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.actionsTitle{\r\n  color: var(--main-color);\r\nfont-size: small;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.lineTitle{\r\n  width: 90%;\r\nposition: absolute;\r\nleft: 5%;\r\ntop: 8%;\r\ncolor: #505050a3;\r\nheight: 1px;\r\nbackground: #3b3b3ba3;\r\n}\r\n\r\n/**************** menu expcept*****************/\r\n.exceptCont{\r\n  position: relative;\r\n  display: block; \r\n  justify-content: center;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: unset;\r\n  /* background-color: aliceblue; */\r\n}\r\n.formCont{\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 86%;\r\n  border-radius: 0px 0px 10px 10px;\r\n  justify-content: center;\r\n  align-items: top;\r\n}\r\n.formCompact{\r\n  position: relative;\r\n  display: block;\r\n  width: 85%;\r\n  height:95%;\r\n}\r\n.formColumn{\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height:20%;\r\n  /* margin-top: 5%; */\r\n}\r\n\r\n\r\n\r\n.formColumn.input-column{\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.input-column label{\r\n  color: aliceblue;\r\n}\r\n.contEventsActions .compactAction{\r\n  width: 95%;\r\n  height: 60%;\r\n}\r\n\r\n.dateExcepcion{\r\n  width: 70%;\r\n  height: 30%;\r\n  background: transparent;\r\n  color: aliceblue;\r\n  border-radius: 10px;\r\n}\r\n.menuActionCell:hover .tooltiptextAction {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n.tooltiptextAction {\r\n  visibility: hidden;\r\n  opacity: 0;\r\n  width: 35%;\r\n  height: 30px;\r\n  background-color: #646464c5;\r\n  border: #003757 2px solid;\r\n  color: rgb(245, 245, 245);\r\n  text-align: center;\r\n  border-radius: 5px;\r\n  /* padding: 10px; */\r\n  position: absolute;\r\n  z-index: 10;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  /* bottom: 80%; */\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  /* height: 20px; */\r\n  transition: opacity 0.3s;\r\n  /* white-space: nowrap; */\r\n  top: 50%;\r\n  font-size: x-small;\r\n  /* margin: 5px; */\r\n}\r\n.tooltiptextAction::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 90%;\r\n  left:0%;\r\n  border-width: 8px;\r\n  border-style: solid;\r\n  border-color: #28282817 transparent transparent transparent;\r\n  transform: translateX(-50%);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
